import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { NAME } from '#client/build-env';
import { ErrorStateSection } from '#client/components/ErrorStateSection';
import { PartnerNextUp } from '#client/components/PartnerDash/PartnerNextUp';
import { ProfileHeader } from '#client/components/ProfileHeader';
import { usePartnerProfileStatus } from '#client/hooks/partnerDash/usePartnerProfileStatus';

function PartnerHome({ partner }) {
  const { formatMessage } = useIntl();
  const {
    statusItems, loading, hasError, name, nameInitials, formationDate
  } = usePartnerProfileStatus({ partner });

  return (
    <Stack spacing={{ xs: 2, sm: 3 }}>
      <ErrorBoundary fallback={<ErrorStateSection />} id={`${NAME}/pages/PartnerHome#ProfileHeader`}>
        <ProfileHeader
          statusItems={statusItems}
          loading={loading}
          hasError={hasError}
          name={name}
          nameInitials={nameInitials}
          formationDate={formationDate}
        />
      </ErrorBoundary>
      <ErrorBoundary fallback={<ErrorStateSection title={formatMessage({ id: 'dashboard.partnerNextUp.title' })} />} id={`${NAME}/pages/PartnerHome#NextUp`}>
        <PartnerNextUp />
      </ErrorBoundary>
    </Stack>
  );
}

PartnerHome.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
};

export default PartnerHome;
